import { useQuery } from '@tanstack/react-query';
import { getAuthConfig, getMe } from '@vinyl/shared';
import { api, ApiError } from '../lib/api.ts';

export const meQueryKey = ['me'] as const;

/** The signed-in User, or null when signed out. */
export function useMe() {
  return useQuery({
    queryKey: meQueryKey,
    queryFn: async () => {
      try {
        return await api(getMe);
      } catch (error) {
        if (error instanceof ApiError && error.status === 401) return null;
        throw error;
      }
    },
    staleTime: 60_000,
  });
}

export function useAuthConfig() {
  return useQuery({ queryKey: ['auth-config'], queryFn: () => api(getAuthConfig), staleTime: Infinity });
}
